export const UPDATE_GUEST_INFO = 'ViewFabricGreetingCard/*/UpdateGuestInfo';
